import axios from "axios";
const PREPR_API = process.env.VUE_APP_PREPR_API;

export async function getMotherlineOverview() {
  const res = await axios.post(PREPR_API, {
    query: `{
                CommonModel (slug: "your-motherline") { 
                        heading
                        text
                        main_image { 
                                url
                        }
                        sub_image { 
                                url
                        }
                        right_section {
                                heading
                                text
                                main_image {
                                        url
                                }
                                button_text
                        }
                }
        }`
  });
  return res.data.data.CommonModel
}

export async function getMotherlineHistory() {
  const res = await axios.post(PREPR_API, {
    query: `{
                        CommonModel (slug: "your-motherline-history") { 
                                heading
                                main_image { 
                                        url
                                }
                        }
                }`
  });
  return res.data.data.CommonModel
}